export class HttpStatus {
    public static readonly OK = 200;
    public static readonly NO_CONTENT = 204;
    public static readonly BAD_REQUEST = 400;
    public static readonly UNAUTHORIZED = 401;
    public static readonly NOT_FOUND = 404;
}